// External Dependencies:
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

// Internal Dependencies:
import rootReducer from 'church-theme-library/redux/reducers/index'
import { getUrlParameter } from 'church-theme-library/utilities/url'

// Config:
const isHeadless = getUrlParameter( 'headless' )

export default function configureStore() {
	// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
	const composeEnhancers =
		typeof window === 'object' &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
			window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__( {
				// trace: true,
				// traceLimit: 20,
				// shouldCatchErrors: true
			} ) : compose
	const preloadedState = window.vlReduxPreloadedState || {}
	delete window.vlReduxPreloadedState

	const store = createStore(
		rootReducer,
		preloadedState,
		composeEnhancers(
			applyMiddleware( thunk )
		)
	)

	if ( isHeadless ) {
		// Save the store in the page source when doing SSR, for use
		// immediately when loaded by a user.
		store.subscribe( () => {
			const storeJson = JSON.stringify( store.getState() )

			let tag = document.getElementById( 'reduxPreloadedState' )

			if ( ! tag ) {
				tag = document.createElement( 'script' )
				tag.id = 'reduxPreloadedState'
				document.getElementsByTagName( 'body' )[0].appendChild( tag )
			}

			tag.text = `window.vlReduxPreloadedState = ${storeJson}`
		} )
	}

	return store
}
